function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21.45 2.13l-5.86 11.88-13.11 1.91a2.87 2.87 0 00-1.59 4.9l9.49 9.24-2.25 13.06a2.87 2.87 0 004.17 3.02l11.72-6.16 11.73 6.16a2.87 2.87 0 004.16-3.02l-2.24-13.05 9.48-9.25a2.87 2.87 0 00-1.59-4.9l-13.1-1.9L26.6 2.12a2.87 2.87 0 00-5.15 0z",
  fillRule: "evenodd"
})));